import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { ChangePasswordComponent } from './change-password.component';

const routes: Routes = [
  Shell.childRoutes([
    {
      path: ':locationId/change-password',
      component: ChangePasswordComponent,
      data: { title: 'Enroll And Pay' },
    },
  ]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChangePasswordRoutingModule {}
